import React from 'react';
import { ExactOnlineSalesQueryProvider } from './ExactOnlineSalesQueryProvider';

export const ExactOnlineSalesProviders = ({ children }: any) => {
	return <ExactOnlineSalesQueryProvider>{children}</ExactOnlineSalesQueryProvider>;
};
